<!--
  The selected group is shown inside this control rather than in a chip below it, so the
  selection costs no extra vertical space in the page header.
-->
<section class="portfolio-selector" [class.has-selection]="selected()">
  <div class="portfolio-input-wrap">
    <input type="text" class="form-control" [formControl]="queryCtrl" [matAutocomplete]="auto"
           [placeholder]="selected() ? displayLabel() : 'Select portfolio group'"
           aria-label="Portfolio group" />

    @if (selected()) {
      <button type="button" class="selector-clear" (click)="clearSelection($event)"
              aria-label="Clear selected portfolio group" title="Clear">
        <mat-icon>close</mat-icon>
      </button>
    }

    @if (loading()) {
      <div class="input-hint">Loading...</div>
    } @else if (nothingFound()) {
      <div class="input-hint">No results</div>
    }
  </div>

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event.option.value)">
    <!-- Names only, one row per name: several registry ids can share one group name and every
         query aggregates them by name, so ids here would imply a distinction the app never makes. -->
    @if (isSearching()) {
      <!-- Typing searches every group the user can reach, so results are shown flat. -->
      <!-- Tracked by name: it is the key every list here is deduplicated on, and the one value
           guaranteed distinct per row. portfolioId is empty for a group, so tracking it gave every
           row the same key and Angular logged NG0955 for all 196 (375351). -->
      @for (o of searchOptions(); track o.portfolioGroupName) {
        <mat-option [value]="o">
          <span class="opt-name">{{ o.portfolioGroupName }}</span>
        </mat-option>
      }
    } @else {
      @if (recentOptions().length > 0) {
        <mat-optgroup label="Recent">
          @for (o of recentOptions(); track o.portfolioGroupName) {
            <mat-option [value]="o">
              <span class="opt-name">{{ o.portfolioGroupName }}</span>
            </mat-option>
          }
        </mat-optgroup>
      }

      @if (remainingOptions().length > 0) {
        <mat-optgroup [label]="recentOptions().length > 0 ? 'Your groups' : ''">
          @for (o of remainingOptions(); track o.portfolioGroupName) {
            <mat-option [value]="o">
              <span class="opt-name">{{ o.portfolioGroupName }}</span>
            </mat-option>
          }
        </mat-optgroup>
      }
    }
  </mat-autocomplete>
</section>
